import React from 'react';

// Style Pack §7 — status pills. Semantic colour only, never decoration.
const TONES = {
    success: 'bg-emerald-100 text-emerald-700',
    pending: 'bg-amber-100 text-amber-700',
    info: 'bg-sky-100 text-sky-700',
    draft: 'bg-gray-100 text-gray-600',
    danger: 'bg-red-50 text-red-700',
    empty: 'bg-white text-gray-400 border border-dashed border-gray-300',
};

export const StatusPill = ({ tone = 'draft', icon: Icon, children, className = '', ...rest }) => (
    <span className={`inline-flex items-center gap-1 rounded px-1.5 py-0.5 text-xs font-medium ${TONES[tone] || TONES.draft} ${className}`} {...rest}>
        {Icon && <Icon className="w-3 h-3" />}
        {children}
    </span>
);
